/* Show SGD-based promo amounts in the shopper's currency. */
(function () {
  var C = (window.Shopify && window.Shopify.currency) || {};
  var rate = parseFloat(C.rate) || 1, cur = C.active || 'SGD';
  function fmt(c) {
    var whole = cur !== 'SGD' ? Math.round(c / 100) * 100 : c;
    var loc = cur === 'SGD' ? 'en-SG' : (document.documentElement.lang || 'en');
    try { return new Intl.NumberFormat(loc, { style: 'currency', currency: cur, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(whole / 100); }
    catch (e) { return cur + ' ' + Math.round(whole / 100); }
  }
  window.dnuvoRate = rate; window.dnuvoMoney = fmt;
  function run() { document.querySelectorAll('[data-sgd]').forEach(function (el) { el.textContent = fmt(Math.round(parseFloat(el.getAttribute('data-sgd')) * rate)); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
